import React from "react";

import styles from "./price-movement-filter.module.scss";

import { Field, Filter, DropdownPaginated } from "components/commons";
import locale from "localization";
import { useApi } from "hooks";
import { getUsers } from "apis/profile.api";
import DatePickerV2 from "components/commons/date-picker-v2/date-picker";

// const SEARCH_TYPE_OPTIONS = [
//   { label: locale.priceMovementId, value: "movementCode" },
//   { label: locale.processedBy, value: "createdByEmail" },
// ];

const PriceMovementFilter = ({
  filterState,
  modifyFilter,
  filterCount,
  applyFilter,
  applyClearFilter,
  resetFilter,
  searchKey,
  modifySearch,
  applySearch,
  applyClearSearch,
}) => {
  const { request: fetchUsers, loading: isLoadingUsers } = useApi({
    api: getUsers,
    params: {
      page: 1,
      perPage: 10,
      portal: "pricetracq",
      role: "pricing",
    },
  });
  return (
    <div className={styles.container}>
      <div className={styles.filter}>
        <Filter
          close={resetFilter}
          clear={applyClearFilter}
          submit={applyFilter}
          filterCount={filterCount}
        >
          <Field className={styles.fieldLabel} labelPosition={"left"} label={locale.effectiveDate}>
            <DatePickerV2
              value={filterState.effectiveAt}
              onChange={(_, { value }) => {
                modifyFilter({ effectiveAt: value });
              }}
              className={styles.effectiveDateAndTime}
              placeholder="Set Date"
            />
          </Field>
          <Field
            className={styles.fieldLabel}
            labelPosition={"left"}
            childrenClassName={styles.fieldContent}
            label={locale.processedBy}
          >
            <DropdownPaginated
              isMultiple
              value={filterState?.processedBy?.value || []}
              isAll={filterState?.processedBy?.isAll || false}
              request={fetchUsers}
              formatRequest={(res) =>
                (res?.users || []).map((d) => ({
                  label: d.email,
                  value: String(d.email),
                }))
              }
              loading={isLoadingUsers}
              placeholder=""
              onChange={(_, { value, isAll }) => {
                modifyFilter({ processedBy: { value, isAll } });
              }}
              selectAllLabel="All"
            />
          </Field>
        </Filter>
        {/* <Field className={styles.search}>
          <SearchTypeField
            value={searchKey}
            onEnter={applySearch}
            onClear={applyClearSearch}
            placeholder="Search..."
            searchWithSymbols={false}
            restrict={false}
            onChange={(_, { value }) => {
              modifySearch(value);
            }}
            searchKeyName={"searchType"}
            searchKeyValue={filterState.searchType}
            searchKeyOptions={SEARCH_TYPE_OPTIONS}
            searchKeyOnChange={(name, { value }) => {
              modifyFilter({ [name]: value });
            }}
            classNameSearchType={styles.searchType}
          />
        </Field> */}
      </div>
    </div>
  );
};

export default PriceMovementFilter;
